import { render } from "./RefuseWithComment.vue?vue&type=template&id=28ed8d42&scoped=true"
import script from "./RefuseWithComment.vue?vue&type=script&lang=js"
export * from "./RefuseWithComment.vue?vue&type=script&lang=js"

import "./RefuseWithComment.vue?vue&type=style&index=0&id=28ed8d42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28ed8d42"

export default script